import React, { useState, useEffect } from "react";
import dashboardclasses from "../../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import { ToastError } from "../../../Components/utils/ToastMessage";
import { v4 as uuid } from "uuid";

import S3FileUpload from "react-s3";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState([]);
    const formDataInputs = watch();
    let firstTime;
    const [subcategories, setSubcategories] = useState([]);
    const [categories, setcategories] = useState([]);

    const categorychange = (name) => {
        const body = JSON.stringify({ categoryname: name });
        Services.Get_SubCategory_Dropdown("POST", body, token)
            .then((res) => {
                if (res.Status === 1) {
                    setSubcategories(res.categories);
                    if (props.editable && firstTime) {
                        firstTime = false;
                        reset({
                            bannertype: props.editable.bannertype,
                            type: props.editable.type,
                            subcategoryid: props.editable?.subcategoryid,
                            categoryid: `${props.editable.categoryid}-${props.editable.categoryname}`,
                        });
                        setbase64(
                            `https://www.heyman.in/static/img/banners/${props.editable.image}`
                        );
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    const getcategories = () => {
        Services.Get_Omnimart_Categories("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setcategories(res.Categories);
                    if (props.editable && props.editable.type == "category") {
                        reset({
                            bannertype: props.editable.bannertype,
                            categoryid: `${props.editable.categoryid}`,
                        });
                        setbase64(props.editable.location);
                        // setValue()
                    } else {
                        categorychange(props.editable.categoryname);
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        firstTime = true;
        getcategories();
        // if (props.editable) {
        //     reset({ ...props.editable });

        //     setbase64(props.editable.images);
        // }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    const handleChange = (file) => {
        if (file.type === "image/png" || file.type === "image/jpeg") {
            const timestamp = Date.now();

            let body = new FormData();
            body.append("image", file);
            body.append("folder", "Banners");
            body.append("bucketName", "heyman-s3");

            Services.UploadImage("POST", body, token)
                .then((res) => {
                    console.log(res);
                    setbase64(res.ImageURL);
                    console.log(res);

                    setValue("imagename", res?.ImageID);
                })
                .catch((err) => {
                    alert(err);
                    console.log(err);
                });
        } else {
            alert(`only Png and jpj images accepted`);
            return false;
        }
        return true;
    };

    const fileuploadDesign = (
        <div className={dashboardclasses["add-item"]}>
            <BsCloudUpload className={dashboardclasses["upload-icon"]} />
            <h5>Drag Your Image here</h5>
            <p>(Only *.jpeg and *.png images will be accepted)</p>
        </div>
    );
    const deleteHandler = (e) => {
        let id = e.currentTarget.getAttribute("id");
        setbase64((prev) => prev.filter((item) => item.id != id));
    };

    const onSubmit = (data) => {
        let body = {
            ...data,
            img_obj_id: props.editable.img_obj_id,
        };

        // return;
        if (props.editable) {
            Services.updateomnibanners(
                "POST",
                JSON.stringify(body),
                token,
                props.editable.bannerId
            )
                .then((res) => {
                    if (res.Status === 1) {
                        props.setmodal(false);
                        props.getCategories();
                        props.tableload(true);
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        } else {
            Services.addOmniBanners("POST", JSON.stringify(data), token)
                .then((res) => {
                    if (res.Status === 1) {
                        props.setmodal(false);
                        props.getCategories();
                        props.tableload(true);
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable ? "Update Banner" : "Add Banner"}
                        </h3>
                        <p>
                            {props.editable ? "Update Banner" : "Add Banner"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Banner Type </label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                disabled={props.editable}
                                {...register("bannertype", {
                                    required: "Banner Type is required",
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select Banner
                                </option>

                                {[...new Set(props.categoryItems)].map(
                                    (item) => (
                                        <option value={item}>{item}</option>
                                    )
                                )}
                            </select>
                            {errors?.bannertype && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.bannertype?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Type </label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("type", {
                                    required: "Type is required",
                                    onChange: (e) => {
                                        setValue("subcategoryid", "");
                                        setValue("categoryid", "");
                                    },
                                })}>
                                {/* <option value="" disabled>
                                    Select Type
                                </option> */}
                                <option value="category">Category</option>
                            </select>
                            {errors?.bannertype && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.bannertype?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Category Name</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                defaultValue={""}
                                {...register("categoryid", {
                                    required: "category name is required",
                                })}>
                                <option value="" disabled>
                                    Select Category
                                </option>
                                {categories.map((item) => (
                                    <option value={`${item.categoryId}`}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            {errors?.categoryid && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.categoryid?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    {formDataInputs.type == "subcategory" && (
                        <div className={dashboardclasses["item-image-upload"]}>
                            <label htmlFor="categoryname">
                                subcategory Name
                            </label>
                            <div className={dashboardclasses["select"]}>
                                <select
                                    defaultValue={""}
                                    {...register("subcategoryid", {
                                        required:
                                            "Subcategory name is required",
                                    })}>
                                    <option value="" disabled>
                                        Select Subcategory
                                    </option>
                                    {subcategories.map((item) => (
                                        <option value={item._id}>
                                            {item.subcategoryname}
                                        </option>
                                    ))}
                                </select>
                                {errors?.subcategoryid && (
                                    <p className={dashboardclasses["error"]}>
                                        {errors?.subcategoryid?.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Banner Images</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <div></div>
                        <div
                            style={{
                                display: "grid",
                                gap: "0.4rem",
                                gridTemplateColumns: "1fr 1fr",
                                justifyItems: "left",
                                width: "70%",
                            }}>
                            <img src={base64} alt="" width={"120px"} />
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Banner"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
